﻿(function () {
	"use strict";
	var __stringStartDataParser = "<!--Inicio.NET-->";
	var __stringEndDataParser = "<!--Final.NET-->";
	var __stringStartLeadIdParser = "<!-- lid.INI {";
	var __stringEndLeadIdParser = "} lid.END -->";
	var __stringStartSimilarDataParser = "<!-- SolicitudViewModel.INI";
	var __stringEndSimilarDataParser = "SolicitudViewModel.END -->";

/*jshint unused:false*/
	var LeadParser = function () {

	};

	var __parseLead = function (responseData) {
		var startPosition = responseData.indexOf(__stringStartDataParser);
		try {
			if (startPosition > -1) {
				var endPosition = responseData.indexOf(__stringEndDataParser);
				var strParsedData = responseData.substring(startPosition, endPosition);
				var strParsedLeadId = __parseLeadId(responseData);
				var oDataFromAsp = _getPropertiesObject_FromDataResponse(responseData);
				var oParsed = {
					"status": 200,
					"data": {
						"content": strParsedData,
						"leadId": strParsedLeadId
					}
				};
				if (oDataFromAsp.status === 200) {
					oParsed.data.solicitudViewModel = __getSolicitudViewModelFromParsedObject(oDataFromAsp.data);
				}
				return oParsed;
			}
			throw "There was an error parsing the asp response";
		} catch (e) {
			return {
				"status": 500,
				"error": e,
				"data" : responseData
			};
		}
	};

	var __parseLeadId = function (responseData) {
		/* Àlex. TODO: Parece prescindible, si en la respuesta desde ASP tenemos el LeadId */ 
		var strParsedData = "";
		var startPosition = responseData.indexOf(__stringStartLeadIdParser);
		if (startPosition > -1) {
			var endPosition = responseData.indexOf(__stringEndLeadIdParser);
			strParsedData = responseData.substring(startPosition + __stringStartLeadIdParser.length, endPosition);
		}
		return strParsedData;
	};

	var _getPropertiesObject_FromDataResponse = function (responseData) {
		var startPosition = responseData.indexOf(__stringStartSimilarDataParser);
		try {
			if (startPosition > -1) {
				var endPosition = responseData.indexOf(__stringEndSimilarDataParser);
				var strParsedData = responseData.substring(startPosition + __stringStartSimilarDataParser.length, endPosition);
				return {
					"status": 200,
					"data": JSON.parse(strParsedData)
				};
			}
		} catch (e) {
			return {
				"status": 500,
				"error": e,
				"data" : responseData
			};
		}
		return {
			"status": 404,
			"error": "Ad properties not found in data for parse",
			"data" : responseData
		};
	};

	var __getSolicitudViewModelFromParsedObject = function (oProperties) {
		return {
			Nombre: oProperties.Nombre,
			Telefono: oProperties.Telefono,
			Email: oProperties.Email,
			Mensaje: oProperties.Mensaje,
			RecibirAlertasInmueblesSimilares: oProperties.RecibirAlertasInmueblesSimilares,
			EsSolicitudPromocion: oProperties.EsSolicitudPromocion,
			Producto: {
				Codigo: oProperties.CodInm,
				Empresa: {
					CodEmp: oProperties.CodEmp
				},
				Oficina: {
					Cod_Ofi: oProperties.CodOfi
				}
			},
			MotivoError: "",
			LeadId: oProperties.LeadId
		};
	};

	var __rejectionMarkers = [
		{marker: "<!-- ajv -->", reason: "SPAM_ERROR"},
		{marker: "<!-- spi -->", reason: "SPAM_ERROR"},
		{marker: "<!-- msa -->", reason: "MASSIVE_ATTACK_ERROR"},
		{marker: "<!-- rpt -->", reason: "DATA_ERROR"}
	];
	var __stringSentForm = 'class="formenviado';

	var __getSubmissionOutcome = function (responseData) {
		var response = typeof responseData === "string" ? responseData : "";
		var rejection = __rejectionMarkers.filter(function (rejectionMarker) {
			return response.indexOf(rejectionMarker.marker) > -1;
		})[0];
		if (rejection) {
			return {result: "failed", reason: rejection.reason};
		}
		if (response.indexOf(__stringSentForm) > -1) {
			return {result: "success", reason: "none"};
		}
		return {result: "failed", reason: "UNKNOWN_ERROR"};
	};

	LeadParser.prototype = {
		constructor: LeadParser,
		Lead: __parseLead,
		SubmissionOutcome: __getSubmissionOutcome
	};

	if (typeof module !== "undefined" && module.exports) {
		module.exports = new LeadParser();
	} else {
		window.LeadParser = new LeadParser();
	}

}());